import React from 'react';
import './Navigation.css';

interface NavigationItem {
  id: number;
  label: string;
  section: string;
}

interface NavigationProps {
  items: NavigationItem[];
  isOpen: boolean;
  onClose: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ items, isOpen, onClose }) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      onClose();
    }
  };

  return (
    <nav className={`navigation ${isOpen ? 'open' : ''}`}>
      <ul>
        {items.map(item => (
          <li key={item.id}>
            <a
              href={`#${item.section}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(item.section);
              }}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;